export default "__VITE_PUBLIC_ASSET__21df8ca0__"